'use client'
import dynamic from 'next/dynamic'
import { useEffect, useRef, useState } from 'react'
import type { NewEquipmentCarouselProps } from './index'

const NewEquipmentCarousel = dynamic(
  () => import('./index').then((m) => m.NewEquipmentCarousel),
  {
    ssr: false,
    loading: () => (
      <section
        aria-hidden="true"
        style={{ minHeight: '48rem', width: '100%' }}
      />
    ),
  },
)

export function NewEquipmentCarouselClient(props: NewEquipmentCarouselProps) {
  const [shouldRender, setShouldRender] = useState(false)
  const placeholderRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const element = placeholderRef.current

    if (!element) {
      return
    }

    if (!('IntersectionObserver' in window)) {
      setShouldRender(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldRender(true)
          observer.disconnect()
        }
      },
      { rootMargin: '300px 0px' },
    )

    observer.observe(element)

    return () => observer.disconnect()
  }, [])

  if (!shouldRender) {
    return (
      <section
        ref={placeholderRef}
        aria-hidden="true"
        style={{ minHeight: '48rem', width: '100%' }}
      />
    )
  }

  return <NewEquipmentCarousel {...props} />
}
